import fetch from 'cross-fetch';
import {
	ChangeEmailAndPasswordAction,
	PortalErrors,
	ChangeEmailAndPasswordRequest,
	ChangeEmailAndPasswordResponse,
} from './change-email-and-password';
import { sameOriginRequestPolicy } from '../actions';
import { RequiredBodyError } from '../error';
import { HTTP_STATUS_BAD_REQUEST, HTTP_STATUS_INTERNAL_SERVER_ERROR } from '../../../helpers/validation/common';

export class RemoteChangeEmailAndPasswordAction {
	private readonly baseUrl: string | null;

	constructor(baseUrl: string | null) {
		this.baseUrl = baseUrl;
	}

	action: ChangeEmailAndPasswordAction = async (
		request?: ChangeEmailAndPasswordRequest
	): Promise<ChangeEmailAndPasswordResponse> => {
		const base: string = this.baseUrl || '';
		if (!request) {
			throw new RequiredBodyError();
		}

		const response: Response = await fetch(
			`${base}/api/login-hub/change-email-and-password`,
			{
				...sameOriginRequestPolicy,
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(request),
				mode: 'cors',
			}
		);

		if (response.ok) {
			const jsonResponse = await response.json();
			return {
				status: response.status,
				redirectUrl: jsonResponse.redirectUrl,
				playerId: jsonResponse.playerId,

			};
		}

		if (response.status === HTTP_STATUS_BAD_REQUEST || response.status === HTTP_STATUS_INTERNAL_SERVER_ERROR) {
			try {
				const jsonResponse = await response.json();
				const errorType = jsonResponse?.error as PortalErrors | undefined;
				return {
					status: response.status as typeof HTTP_STATUS_BAD_REQUEST | typeof HTTP_STATUS_INTERNAL_SERVER_ERROR,
					error: errorType,
				};
			} catch (jsonError) {
				return {
					status: response.status as typeof HTTP_STATUS_BAD_REQUEST | typeof HTTP_STATUS_INTERNAL_SERVER_ERROR,
				};
			}
		}

		return {
			status: response.status,
		};
	};
}
